// Generated by CoffeeScript 1.9.3
var MarginLeft, _Length,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_Length = require('./_Length');

module.exports = MarginLeft = (function(superClass) {
  extend(MarginLeft, superClass);

  function MarginLeft() {
    return MarginLeft.__super__.constructor.apply(this, arguments);
  }

  return MarginLeft;

})(_Length);



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/renderKid/styles/rule/declarationBlock/MarginLeft.js
// module id = 384
// module chunks = 0